import axios from "axios";
import { getcurrentToken } from "./Auth";
export function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}
export function AxiosConfiguration() {
  let token = getcurrentToken();
  const csrftoken1 = getCookie("csrf_token");
  return axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "multipart/form-data",
      "X-CSRFToken": csrftoken1,
    },
  });
}
export function AxiosSurveyConfiguration() {
  const csrftoken1 = getCookie("csrf_token");
  return axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`,
      headers: {
      "X-CSRFToken": csrftoken1,
    },
  });
}
